import styled from "styled-components";
import color from "../assets/colors";

export const TopBar = styled.div`
   position: absolute;
   width: 100%;
   height: 57px;
   left: 0px;
   top: 0px;
   background: ${props => props.color || color.colorBtn};
   display: flex;
   align-items: center;

   color: white;

   .styleArrow {
      padding-left: 28px;
      width: 4em;
   }

   .ttitle {
      width: calc(100% - 8em);

      & p {
         text-transform: uppercase;
         text-align: center;
      }
   }
`;
